import React from 'react';
import Meta from "../components/Meta";
import PageBanner from '../components/PageBanner';
import GalleryBox from '../components/GalleryBox';

const Gallery = () => {
    return (
        <>
            <Meta title="Gallery - THE CUTTING BAR" />
            <PageBanner imageUrl="assets/images/background/2.jpg" heading="Gallery" />
            <GalleryBox />
        </>
    );
}

export default Gallery;
